import { useCreateRecommendation } from '@/api/recommendation/recommendation.hooks';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { CirclePlus } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import {
  RecommendationForm,
  RecommendationFormState,
  emptyRecommendationForm,
} from './RecommendationForm';

export const AddRecommendation = ({ refetch }: { refetch: () => void }) => {
  const mutation = useCreateRecommendation();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState<RecommendationFormState>(
    emptyRecommendationForm(),
  );

  const handleCreate = () => {
    if (!form.textFr || !form.textEn || !form.whyFr || !form.whyEn) {
      toast.error('Tous les champs texte sont obligatoires');
      return;
    }
    if (form.symptomTypes.length === 0) {
      toast.error('Sélectionnez au moins un symptôme');
      return;
    }

    mutation.mutate(form, {
      onSuccess: () => {
        setOpen(false);
        setForm(emptyRecommendationForm());
        refetch();
        toast.success('Recommandation créée avec succès', { duration: 3000 });
      },
      onError: () => {
        toast.error('Erreur lors de la création', { duration: 3000 });
      },
    });
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        setOpen(v);
        if (!v) setForm(emptyRecommendationForm());
      }}
    >
      <DialogTrigger asChild>
        <Button>
          <div className="flex flex-row gap-2 items-center">
            <CirclePlus size={24} />
            <span>Ajouter</span>
          </div>
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] overflow-y-auto max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-center">
            Ajouter une recommandation
          </DialogTitle>
          <DialogDescription className="text-center">
            Associez des symptômes à une recommandation
          </DialogDescription>
        </DialogHeader>

        <RecommendationForm state={form} onChange={setForm} />

        <DialogFooter className="flex gap-2">
          <DialogClose asChild>
            <Button variant="ghost">Annuler</Button>
          </DialogClose>
          <Button
            variant="default"
            onClick={handleCreate}
            disabled={mutation.isPending}
          >
            {mutation.isPending ? 'Création...' : 'Créer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
